function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7447 7.74043C19.5872 9.01986 20.0085 10.4397 20.0085 12C20.0085 14.1844 19.2206 16.0645 17.6447 17.6404C16.0688 19.2163 14.1887 20.0043 12.0043 20.0043L12 22L8.02553 18.9745L12 16L12.0043 17.9915C13.6582 17.9915 15.0702 17.4064 16.2404 16.2362C17.4106 15.066 17.9957 13.6539 17.9957 12C17.9957 11.0638 17.7617 10.1277 17.2936 9.19149L18.7447 7.74043ZM12.0043 6.00851C10.3503 6.00851 8.9383 6.59361 7.76808 7.76383C6.59787 8.93405 6.01277 10.3461 6.01277 12C6.01277 13.0298 6.24681 13.966 6.71489 14.8085L5.26383 16.2596C4.42127 14.9801 4 13.5603 4 12C4 9.81559 4.78794 7.93547 6.36383 6.35957C7.93972 4.78368 9.81985 3.99574 12.0043 3.99574L12 2L15.983 5.02553L12 8L12.0043 6.00851Z",
  fill: "black"
});

var SvgIcoAutorenew = function SvgIcoAutorenew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoAutorenew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-autorenew.64c1349d.svg";
export { ForwardRef as ReactComponent };